<template>
  <div class="lh-homes imgs" style="background-image:url(img/c1.png)">
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：合法权利与业务</span></div>
    <div class="lh-power clearfix">
    	<h3 class="title"><img src="img/c15.png" /></h3>
    	<div class="lh-power1"><img src="img/c14.png" /></div>
    </div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:3,type:'culture'}
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
      that.footerData={audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:3,type:'culture',progress:true};
        	setTimeout(function(){
    				var tips='<div class="lh-end"><h3>消息<i class="iconfont icon-l-close tip-close"></i></h3><div class="cont">当前课件已学习完成，请学习下一个课件。</div><a href="javascript:;" id="Back">确定</a></div>';
    				if($('.lh-end').length<=0){
    					$('#app').append(tips);
    				}
    			},5000);
    			$(document).on('click','.tip-close',function(){
    				$('.lh-end').remove();
    			});
    			//结束后返回
          document.addEventListener('UniAppJSBridgeReady', function () {  
          	  //自定义点击事件
              $(document).on('click','#Back', function (evt) {  
                console.log("aa")  
               	uni.navigateBack({})
              });  
          });
    },
	components:{
		Footer
	},
	methods:{
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		}
	}
}
</script>
